/* eslint-disable import/prefer-default-export */
import { createAsyncThunk } from '@reduxjs/toolkit';
import HoggaxService from '@/services/HoggaxService';

const handler = (name, asyncFunction) =>
  createAsyncThunk(`hoggax/${name}`, async (arg) => {
    const data = await asyncFunction(arg);
    return data;
  });

export const sendHoggaxQuoteRequest = handler(
  'sendHoggaxQuoteRequest',
  HoggaxService.sendHoggaxQuoteRequest
);
export const getPropertyStarredContacts = handler(
  'getPropertyStarredContacts',
  HoggaxService.getPropertyStarredContacts
);
